<!--<div class="div-action-top">
  <div class="left">
    <div class="form-filter ant-form ant-form-inline">
      <input style="width: 200px" [(ngModel)]="searchText" (ngModelChange)="doSearch()" nz-input
             placeholder="Nhập barcode sản phẩm"/>
    </div>
  </div>
</div>-->
<div class="card card-custom gutter-b">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">
        Tra cứu vật tư
      </h3>
    </div>
    <div class="card-toolbar">
      Nhập / quét barcode mã vật tư: &nbsp;<input style="width: 200px" [(ngModel)]="searchText" (ngModelChange)="doSearch()" nz-input
             placeholder="Mã vật tư"/>
    </div>
  </div>
  <div class="card-body" *ngIf="searchData">
    <div>
      <div class="input-wrap" nz-row>
        <label class="title-detail" nz-col [nzSpan]="4">Mã vật tư</label>
        <div nz-col [nzSpan]="6">
          <strong>{{searchData.code}}</strong>
        </div>
      </div>
      <div class="input-wrap" nz-row>
        <label class="title-detail" nz-col [nzSpan]="4">Barcode</label>
        <div nz-col [nzSpan]="6">
          <strong>{{searchData.parcelDetailCode}}</strong>
        </div>
      </div>
      <div class="input-wrap" nz-row>
        <label class="title-detail" nz-col [nzSpan]="4">Tên vật tư</label>
        <div nz-col [nzSpan]="6">
          <strong>{{searchData.name}}</strong>
        </div>
      </div>
      <div class="input-wrap" nz-row>
        <label class="title-detail" nz-col [nzSpan]="4">Mã lô</label>
        <div nz-col [nzSpan]="6">
          <strong>{{searchData.batchCode}}</strong>
        </div>
      </div>
      <div class="input-wrap" nz-row>
        <label class="title-detail" nz-col [nzSpan]="4">Chi tiết</label>
      </div>
    </div>
    <div>
      <nz-table #basicTable [nzData]="searchData.logs">
        <thead>
        <tr>
          <th>Hành động</th>
          <th>Ngày</th>
          <th>Người nhập/xuất</th>
          <th>Mã phiếu</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of basicTable.data">
          <td>{{ data.action }} <strong>{{data.recipient}}</strong></td>
          <td>{{ data.dateLog | date: 'dd/MM/yy HH:mm' }}</td>
          <td>{{ data.userName }}</td>
          <td>
            {{data.code}}
          </td>
        </tr>
        </tbody>
      </nz-table>
    </div>
  </div>

</div>
